import React, { Component } from 'react'

export class AsLegendSizeContinuousPoint extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidUpdate() {
    this.ref.current.data = this.props.data
  }

  render() {
    return (
      <as-legend-size-continuous-point ref={this.ref} slot={this.props.slot} orientation={this.props.orientation} scale={this.props.scale}></as-legend-size-continuous-point>      
    )
  }
}

export default AsLegendSizeContinuousPoint
